import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  email?: string;
  name?: string;
  picture?: string;
  sub?: string;
}

interface AuthState {
  isUserLogin: boolean;
  user: User | null;
}

const getUserFromStorage = (): User | null => {
  try {
    const userStr = sessionStorage.getItem("user");
    if (!userStr) return null;
    return JSON.parse(userStr) as User;
  } catch (error) {
    console.error("Error parsing user from sessionStorage:", error);
    sessionStorage.removeItem("user");
    return null;
  }
};

const initialState: AuthState = {
  isUserLogin: Boolean(sessionStorage.getItem("user")),
  user: getUserFromStorage(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isUserLogin = Boolean(action.payload);
      if (action.payload) {
        sessionStorage.setItem("user", JSON.stringify(action.payload));
      } else {
        sessionStorage.removeItem("user");
      }
    },
    logout: (state) => {
      state.user = null;
      state.isUserLogin = false;
      sessionStorage.removeItem("user");
    },
    checkAuthState: (state) => {
      const user = getUserFromStorage();
      const isUserLogin = Boolean(sessionStorage.getItem("user"));
      state.isUserLogin = isUserLogin;
      state.user = user;
    },
  },
});

export const { setUser, logout, checkAuthState } = authSlice.actions;

export default authSlice.reducer;
